module.exports = __webpack_public_path__ + "img/md.90ce5a48.png";